import { Subscript } from '@tiptap/extension-subscript';
import { markInputRule, markPasteRule } from '@tiptap/core';

// Match text with two commas on either side
// Example: ,,subscript,,
const inputRegex = /(?:^|\s)((?:,,)((?:[^,]+))(?:,,))$/;
const pasteRegex = /(?:^|\s)((?:,,)((?:[^,]+))(?:,,))/g;

export const CustomSubscript = Subscript.extend({
   addInputRules() {
      return [
         markInputRule({
            find: inputRegex,
            type: this.type,
         }),
      ];
   },

   addPasteRules() {
      return [
         markPasteRule({
            find: pasteRegex,
            type: this.type,
         }),
      ];
   },
});
